import { render, staticRenderFns } from "./link-dialog-service.vue?vue&type=template&id=73215061&"
import script from "./link-dialog-service.vue?vue&type=script&lang=js&"
export * from "./link-dialog-service.vue?vue&type=script&lang=js&"
import style0 from "./link-dialog-service.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports